import React, { Component } from 'react';
import { __, __n } from 'i18n-for-browser';
import Scrollbar from 'react-scrollbars-custom';
import JSZip from 'jszip';
import FileSaver from 'file-saver';

import GameDetails from '../elements/GameDetails';
import { ImageThumbnail } from '../elements/ImageThumbnail';
import GoBackButton from "../elements/GoBackButton";
import connect from "react-redux/es/connect/connect";

import apiCall from '../apiCall';

import Loader from '../../assets/img/loader.svg';

class SchoolPortalMedia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      showGroepsIndeling: false,
      downloading: false,
      videos: {
        projectVideos: [],
        schoolClassVideos: [],
      },
      photos: {
        projectPhotos: [],
        schoolClassPhotos: [],
        teamPhotos: [],
      },
    }
  }

  componentWillMount() {
    this.fetchData();
    document.body.classList.add('schoolPage');
  }

  fetchData() {
    this.setState({ downloading: true });
    apiCall(`/project/${this.props.match.params.projectId}/${this.state.activeTab ? 'videos' : 'photos'}`)
      .then((result) => {
        this.setState({
          [this.state.activeTab ? 'videos' : 'photos']: result,
          downloading: false,
        });
      });
  }

  toggleTab = (no) => {
    this.setState({
      activeTab: no
    }, () => {
      this.fetchData();
    });
  };

  downloadImages = () => {
    const { project } = this.props;

    if (!this.state.downloading) {
      this.setState({ downloading: true });

      const imgs = document.getElementsByClassName('imageThumbnail-download');
      const promises = [];
      for (let i = 0; i < imgs.length; i++) {
        promises.push(new Promise((resolve) => fetch(imgs[i].dataset.url).then(r => resolve(r.blob()))));
      }
      Promise.all(promises).then((blobs) => {
        const zip = JSZip();
        blobs.forEach((blob, i) => {
          zip.file(`foto-${i}.jpeg`, blob);
        });
        zip.generateAsync({ type: 'blob' }).then(zipFile => {
          const currentDate = new Date().getTime();
          const fileName = `fotos-${currentDate}.zip`;
          return FileSaver.saveAs(zipFile, fileName);
        }).then(() => this.setState({ downloading: false }));
      });
    }
  };

  getTabPage = () => {
    //Foto's
    let images = this.state.photos.projectPhotos.concat(this.state.photos.schoolClassPhotos.reduce((acc, scp) => {
      return acc.concat(scp.photos);
    }, [])).concat(this.state.photos.teamPhotos);

    if (this.props.project.photoPlaylist) {
      images = images.filter(current => this.props.project.photoPlaylist.includes(current.PhotoId));
    }

    return (
      <div className={'content-section'}>
        <Scrollbar style={{ margin: "20px auto", width: '800px', height: '70vh', minHeight: 300 }} >
          <div className='container semiWide'>
            {images.map((photo, i) => {
              return <ImageThumbnail key={i} image={photo.Photo.url} />
            })}
          </div>
        </Scrollbar>
      </div>
    );
  };

  render() {

    // const { state, props } = this;
    let images = this.state.photos.projectPhotos.concat(this.state.photos.schoolClassPhotos.reduce((acc, scp) => {
      return acc.concat(scp.photos);
    }, [])).concat(this.state.photos.teamPhotos);
    return (
      <div className="portal-home school-class-media darkBckg">
        <div className="desktop-content-center">
          <GameDetails color="white" />
          <GoBackButton history={this.props.history} />
        </div>
        <p className="score-text-center" style={{ marginTop: '10px', color: 'white', fontWeight: 'bold', zIndex: 1, height: 0, position: 'relative', top: '-25px' }}>
          {__("sim_fotos_filmpjes_blijven_2_maand_geldig")}
        </p>
        <div className="buttonRow media">
          <button className={`download button--green ${images.length ? '' : 'disabled'}`} onClick={() => this.downloadImages()}><span>{`${__("sim_download")} ${__n('sim_foto', 0)}`}</span></button>
        </div>
        {this.getTabPage()}

        <div className={this.state.downloading ? 'loader-download show' : 'loader-download'}>
          <img src={Loader} alt='loader' />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
}))(SchoolPortalMedia);



// WEBPACK FOOTER //
// ./src/components/desktop/SchoolPortalMedia.js